import * as React from "react";
import dayjs from "dayjs";
import * as ro from "dayjs/locale/ro";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { StaticDatePicker } from "@mui/x-date-pickers/StaticDatePicker";
import { CalendarPicker } from "@mui/x-date-pickers/CalendarPicker";

import axios from "axios";
import { useSearchParams, useParams } from "react-router-dom";

import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import Typography from "@mui/material/Typography";

import AppForm from "./AppForm";

import Header from "./components/header";

const isWeekend = (date) => {
  const day = date.day();
  //is older then 60 days
  const older = dayjs(date).isAfter(dayjs().add("60", "day"), "day");
  // console.log("day+60", older);

  return day === 0 || day === 6 || older;
};

export default function Appointment() {
  const { serviceType } = useParams();

  const [value, setValue] = React.useState(null);
  const [slot, setSlot] = React.useState(null);
  const [data1, setData1] = React.useState(null);
  const [appointment, setAppointment] = React.useState(null);
  const [confirm, setConfirm] = React.useState(false);
  const [login, setLogin] = React.useState(false);

  const fetchData = async (value) => {
    const url =
      process.env.REACT_APP_API_URL +
      "/slots?date=" +
      value +
      "&service=" +
      serviceType;

    const req = await axios.get(url);
    setData1(req.data);
    // console.log("fetchValue", url, value, data1);
  };

  const prepareAppoitment = () => {
    let app_data = {
      doctor: slot.uniqueid.slice(0, -4),
      doctor_name: slot.doctor_name,
      status: "created",
      service_type: slot.service_type,
      p_name: "",
      p_phone: "",
      p_email: "",
      start_time: dayjs(value)
        .tz("Europe/Bucharest")
        .set("hour", slot.start.split(":")[0])
        .set("minute", slot.start.split(":")[1]),
      end_time: dayjs(value)
        .tz("Europe/Bucharest")
        .set("hour", slot.end.split(":")[0])
        .set("minute", slot.end.split(":")[1]),
    };

    // console.log("Prepare Appointment: ", app_data);
    setAppointment(app_data);

    // console.log("prepareAppoitment", slot, value);
    // console.log("prepareAppoitment", app_data);
  };

  const handleApp = (data) => {
    // console.log("handleApp", data);

    let new_data = {
      p_name: data.nume,
      p_email: data.email,
      p_phone: data.phone,
    };

    let app_data = { ...appointment, ...new_data };
    // console.log("axios", app_data);

    //   const headers = {
    //     'Authorization': 'Bearer my-token',
    //     'My-Custom-Header': 'foobar'
    // };
    axios
      .post(process.env.REACT_APP_API_URL + "/appointment", app_data)
      .then((response) => {
        // console.log(response);
        setValue(null);
        setSlot(null);
        setAppointment(null);
        setConfirm(true);
      });
  };

  React.useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user && user.token) {
      // console.log("we have user");
      setLogin(true);
    }
  }, []);

  return (
    <>
      {login && <Header />}
      <Grid
        sx={{ flexGrow: 1, margin: 1 }}
        container
        spacing={1}
        justifyContent="center"
        alignItems="stretch"
      >
        <Grid item sm={4} xs={12}>
          <Paper sx={{ height: "100%" }}>
            <Typography
              variant="h6"
              gutterBottom
              p={1}
              sx={{ textAlign: "center" }}
            >
              Selecteaza o data pentru programare
            </Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={ro}>
              <CalendarPicker
                shouldDisableDate={isWeekend}
                disablePast={true}
                date={value}
                renderInput={(params) => <TextField {...params} />}
                onChange={(newValue) => {
                  // console.log(dayjs(newValue).format("YYYY-MM-DD"));
                  fetchData(dayjs(newValue).format("YYYY-MM-DD"));
                  setValue(newValue);
                  setSlot(null);
                  setAppointment(null);
                  setConfirm(false);
                }}
              />
            </LocalizationProvider>
          </Paper>
        </Grid>
        <Grid item sm={7} xs={12}>
          <Paper sx={{ height: "100%" }}>
            {appointment && (
              <AppForm app={appointment} slot={slot} onApp={handleApp} />
            )}

            {!value && !appointment && (
              <Box
                component="span"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                  padding: 5,
                }}
              >
                {confirm && (
                  <Typography
                    variant="h6"
                    gutterBottom
                    sx={{
                      p: 1,
                      textAlign: "center",
                      opacity: 1,
                      lineHeight: 1.1,
                    }}
                  >
                    Programarea dvs. a fost adaugata cu succes.
                  </Typography>
                )}

                <Typography
                  variant="subtitle1"
                  gutterBottom
                  sx={{
                    p: 6,
                    textAlign: "center",
                    opacity: 0.6,
                    lineHeight: 1.1,
                  }}
                >
                  Selecteaza o zi din partea stanga <br />
                  pentru a afisa programarile disponibile.
                </Typography>
              </Box>
            )}
            {value && !appointment && (
              <>
                <Typography
                  variant="h5"
                  gutterBottom
                  p={1}
                  sx={{ textAlign: "center" }}
                >
                  {dayjs(value).format("DD MMMM YYYY")}
                  {slot ? " la " + slot.start : ""}
                </Typography>

                {data1 && (
                  <Box
                    sx={{
                      m: 3,
                      display: "flex",
                      flexWrap: "wrap",
                    }}
                  >
                    {data1.map((doctor) => (
                      <div key={doctor._id}>
                        <Typography
                          variant="h6"
                          component="div"
                          gutterBottom
                          sx={{ ml: 0.5 }}
                        >
                          {doctor.name}
                        </Typography>
                        {doctor.all_doctor_slots.length === 0 ? (
                          <Button
                            variant="outlined"
                            fullWidth
                            disabled={true}
                            size="small"
                            sx={{ m: 0.2, mb: 2 }}
                          >
                            Nu exista sloturi disponibile pentru ziua selectata.
                          </Button>
                        ) : (
                          ""
                        )}
                        <div>
                          {doctor.all_doctor_slots.map((time) => (
                            <Button
                              variant={
                                slot?.uniqueid === time.uniqueid
                                  ? "contained"
                                  : "outlined"
                              }
                              // size="large"
                              key={time.start}
                              sx={{ m: 0.2, mb: 2 }}
                              onClick={() => {
                                // console.log("slot_time", time);
                                setSlot({
                                  ...time,
                                  service_type: doctor.specialitate,
                                  doctor_name: doctor.name,
                                });
                              }}
                            >
                              {time.start} - {time.end}
                            </Button>
                          ))}
                        </div>
                      </div>
                    ))}
                  </Box>
                )}
                {slot && (
                  <Button
                    variant="contained"
                    fullWidth
                    onClick={() => {
                      prepareAppoitment();
                    }}
                    sx={{ m: 2, width: "calc(100% - 36px)" }}
                  >
                    Adauga Programare
                  </Button>
                )}
              </>
            )}
          </Paper>
        </Grid>
      </Grid>
    </>
  );
}
